<template>
  <div class="page-wrapper">
    <main class="main">
      <div class="page-header">
        <div class="container">
          <h1 class="page-title mb-0" id="movetarget">
            {{ duoyuyan(service) }}
          </h1>
        </div>
      </div>
      <nav class="breadcrumb-nav mb-10 pb-8">
        <div class="container">
          <ul class="breadcrumb">
            <li>
              <router-link to="/">{{ $yuyanbao.shouye }}</router-link>
            </li>
            <li>
              {{ duoyuyan(service) }}
            </li>
          </ul>
        </div>
      </nav>
      <div class="page-content">
        <div class="container">
          <section class="title-section show-code-action">
            <h2 class="title">
              {{ duoyuyan(service) }}
            </h2>
            <p
              style="text-align: left"
              v-html="duoyuyan(service, 'miaoshu')"
            ></p>
          </section>
          <section class="element-section text-center mt-10 mb-10 pb-2">
            <div class="tab-pane active order">
              <div class="order-details-wrapper mb-5">
                <h4 class="title text-uppercase ls-25 mb-5">
                  {{ $yuyanbao.xiangqing }}
                </h4>
                <table class="order-table mb-8">
                  <tbody>
                    <tr v-if="service.leixing !== 1">
                      <td style="text-align: left">
                        {{ duoyuyan(leixing) }}
                      </td>
                      <td>
                        <img
                          style="width: 50px; height: 50px"
                          :src="leixing.tupian || $tupianmoren"
                        />
                      </td>
                    </tr>
                    <tr v-for="(item, index) in wenti" :key="index">
                      <td style="text-align: left">
                        {{ duoyuyan(item) }}
                      </td>
                      <td>
                        {{ (item.jiage / 100).toFixed(2) + $shezhi.huobi }}
                      </td>
                    </tr>
                    <tr>
                      <td style="text-align: left"></td>
                      <td>
                        {{ (zonge / 100).toFixed(2) + $shezhi.huobi }}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div class="form checkout-form">
                  <div class="row gutter-sm">
                    <div class="col-xs-6">
                      <div class="form-group">
                        <label>{{ $yuyanbao.xing }} *</label>
                        <input
                          type="text"
                          class="form-control form-control-md"
                          v-model="xing"
                          required
                        />
                      </div>
                    </div>
                    <div class="col-xs-6">
                      <div class="form-group">
                        <label>{{ $yuyanbao.ming }} *</label>
                        <input
                          type="text"
                          class="form-control form-control-md"
                          v-model="ming"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row gutter-sm">
                    <div class="col-xs-6">
                      <div class="form-group">
                        <label>{{ $yuyanbao.dianhua }} *</label>
                        <input
                          type="text"
                          class="form-control form-control-md"
                          v-model="dianhua"
                          required
                        />
                      </div>
                    </div>
                    <div class="col-xs-6">
                      <div class="form-group">
                        <label>{{ $yuyanbao.youxiang }} *</label>
                        <input
                          type="text"
                          class="form-control form-control-md"
                          v-model="email"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>{{ $yuyanbao.dizhi }} *</label>
                    <input
                      type="text"
                      class="form-control form-control-md"
                      v-model="dizhi"
                      required
                    />
                  </div>
                  <div class="row gutter-sm">
                    <div class="col-xs-6">
                      <div class="form-group">
                        <label>{{ $yuyanbao.codepostal }} *</label>
                        <input
                          type="text"
                          class="form-control form-control-md"
                          v-model="codepostal"
                          required
                        />
                      </div>
                    </div>
                    <div class="col-xs-6">
                      <div class="form-group">
                        <label>{{ $yuyanbao.chengshi }} *</label>
                        <input
                          type="text"
                          class="form-control form-control-md"
                          v-model="chengshi"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div class="form-group mt-3">
                    <label for="order-notes">{{ $yuyanbao.beizhu }}</label>
                    <textarea
                      class="form-control mb-0"
                      cols="30"
                      rows="4"
                      v-model="beizhu"
                    ></textarea>
                  </div>
                </div>
              </div>
              <span
                @click="post_commande_service_http"
                class="btn btn-dark btn-outline btn-rounded ls-25 ml-4"
              >
                <div class="btn-text">
                  <i class="w-icon-visit"></i>
                </div>
              </span>
            </div>
          </section>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { postDingDan } from "@/api/dingdan";

export default {
  name: "ServiceCommande",
  components: {},
  data() {
    return {
      service: {},
      leixing: {},
      wenti: [],
      beizhu: "",
      xing: "",
      ming: "",
      dianhua: "",
      email: "",
      dizhi: "",
      codepostal: "",
      chengshi: "",
      loading: false,
      zonge: 0,
    };
  },
  mounted() {
    const { xing, ming, dianhua, email, dizhi, codepostal, chengshi } =
      this.$store.state.yonghu;
    this.xing = xing;
    this.ming = ming;
    (this.dianhua = dianhua), (this.email = email);
    this.dizhi = dizhi;
    this.codepostal = codepostal;
    this.chengshi = chengshi;
    this.service = JSON.parse(localStorage.getItem("service"));
    this.leixing = JSON.parse(localStorage.getItem("leixing"));
    this.wenti = JSON.parse(localStorage.getItem("wenti"));
    this.zonge = 0;
    for (let i = 0, len = this.wenti.length; i < len; i += 1) {
      this.zonge += this.wenti[i].jiage;
    }
  },
  methods: {
    post_commande_service_http() {
      const now = new Date();
      const opt = {
        leixing: 2,
        gongsi: localStorage.getItem("fuwugongsi"),
        xiangqing: {
          service: this.service,
          leixing: this.leixing,
          wenti: this.wenti,
        },
        xiadanriqi: `${now.getFullYear()}-${
          now.getMonth() + 1 < 10
            ? `0${now.getMonth() + 1}`
            : now.getMonth() + 1
        }-${now.getDate() < 10 ? `0${now.getDate()}` : now.getDate()}`,
      };
      this.$store.state.yonghu.id &&
        Object.assign(opt, { yonghu: this.$store.state.yonghu.id });
      this.xing && Object.assign(opt, { xing: this.xing });
      this.ming && Object.assign(opt, { ming: this.ming });
      this.dianhua && Object.assign(opt, { dianhua: this.dianhua });
      this.email && Object.assign(opt, { email: this.email });
      this.dizhi && Object.assign(opt, { dizhi: this.dizhi });
      this.codepostal && Object.assign(opt, { codepostal: this.codepostal });
      this.chengshi && Object.assign(opt, { chengshi: this.chengshi });
      this.beizhu && Object.assign(opt, { beizhu: this.beizhu });
      this.shangdanriqi &&
        Object.assign(opt, { shangpinriqi: this.shangdanriqi });
      this.fangshi && Object.assign(opt, { fangshi: this.fangshi });
      this.zhuangtai && Object.assign(opt, { zhuangtai: this.zhuangtai });
      this.zhifu && Object.assign(opt, { zhifu: this.zhifu });
      this.fukuan && Object.assign(opt, { fukuan: this.fukuan });
      this.zonge && Object.assign(opt, { zonge: this.zonge });
      this.zhekou && Object.assign(opt, { zhekou: this.zhekou });
      this.yunfei && Object.assign(opt, { yunfei: this.yunfei });
      this.loading = true;
      postDingDan(opt)
        .then((data) => {
          this.toast_http({ status: data.status });
          if (data.status === "SUCCESSED")
            this.$router.push({
              path: "/receipt",
              query: {
                ukey: data.data,
              },
            });
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped>
.tree-item {
  width: 100%;
  padding-top: 100%;
  box-shadow: 0 2rem 3rem rgb(0 0 0 / 5%), 0 0 5px rgb(0 0 0 / 5%);
  border-radius: 2rem;
  cursor: pointer;
  position: relative;
}

.tree-item-main {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  border-radius: 2rem;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 5px;
  font-size: 20px;
  background-color: #03a9f4;
  color: white;
  font-weight: bold;
}

.delete {
  position: absolute;
  right: 0;
  top: 2px;
  height: 13px;
  width: 13px;
}

.delete > i {
  position: absolute;
  top: 0;
  left: 0;
  transition: all 0.3s;
  cursor: pointer;
}

.delete > i:hover {
  transform: rotate(90deg);
}

.btn-text {
  position: relative;
  display: inline-block;
  width: auto;
}

.xuanzhuan {
  position: absolute;
  top: 8px;
  left: 0;
  animation: anixuanzhuan 0.8s infinite linear;
}

@keyframes anixuanzhuan {
  0% {
    transform: rotate(0deg);
  }

  25% {
    transform: rotate(90deg);
  }

  50% {
    transform: rotate(180deg);
  }

  75% {
    transform: rotate(270deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
